import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from "src/app/Service/notification.service";
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { LoginService } from 'src/app/Service/login.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';

@Component({
    selector: 'app-Change-Password-Otp-Verification-dialog',
    templateUrl: './Change-Password-Otp-Verification.component.html'
})
export class OTPVerificationComponent implements OnInit {  
    public actionButtonText: string = "Verify";
    memberId: number|null = null;
    ShowMailID:string ="";
     public OTPVerificationForm: FormGroup = new FormGroup({
        Code: new FormControl('',[Validators.required])
    });

    constructor(  public _dialogRef: MatDialogRef<OTPVerificationComponent>,
        private _notificationService:NotificationService,
        @Inject(MAT_DIALOG_DATA) public _data: any, private loginService: LoginService,private encryptDecryptService: EncryptDecryptService) {

    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {
      //  this.memberId = this._commonService.getLoggedInUserId();
      
       if (this._data.MailId)
            this.ShowMailID ="XXXXX" + this._data.MailId.substring(this._data.MailId.length-14);
       
    }
    

    /**
     * Save project
     */
    saveProject() {
        
        let otp_input ={
            OTP : this.getFormValue("Code").trim() ,
            UserName: this._data.username,
            MailId: this._data.MailId,
            Flag : "VERIFY",
            password:this._data.password
          }
        this.loginService.PostForgetPasswordOTP(otp_input).subscribe(res =>{                     
            if(res.successCode==200)
            {
                this._notificationService.showToast(res.successMessage, "Success");
                this._dialogRef.close(res);
            }
            else
            {
                this._notificationService.showToast(res.successMessage, "Warning");
            }
          });
        
    }

    /**
     * Get GroupForm Controls value
     * @param controlName ControlName
     */
    getFormValue(controlName: string): any {
        return this.OTPVerificationForm.get(controlName)?.value;
    }

    

    /**
     * Close modal dialog
     */
    closeDialog() {
        this._dialogRef.close();
    }
   
    
}